import { Box, InputLabel, MenuItem } from '@mui/material'
import Select, { SelectProps } from '@mui/material/Select'

export function SelectField({
  options,
  value,
  onChange,
  label,
  ...props
}: SelectProps & {
  options: { label: string; value: number | string }[]
  label?: string
}) {
  return (
    <Box>
      <InputLabel id={`${label}-label`} className='text-[#2f2b3d]'>
        {label}
      </InputLabel>
      <Select
        labelId={`${label}-label`}
        id={`${label}-select`}
        value={value}
        label={label}
        onChange={onChange}
        {...props}
        sx={{
          height: 38,
          borderRadius: 3,
          minWidth: 80,
          width: '100%'
        }}
      >
        {options.map(option => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </Select>
    </Box>
  )
}
